import axios from "axios";
import { API_URLS } from "./config";

export const updateUserConsent = async (): Promise<any> => {
  try {
    const response = await axios.post(API_URLS.UPDATE_USER_CONSENT);
    return response.data;
  } catch (error) {
    console.error("Error updating user consent:", error);
    throw error;
  }
};

export const verifyCaptcha = async (formData: any): Promise<any> => {
  try {
    const responseData = await axios.post(`${API_URLS.CAPTCH_VERIFY}`, formData);
    return responseData.data;
  } catch (error) {
    console.error("Error updating user consent:", error);
    throw error;
  }
};

export const generatePassword = async (formData: any): Promise<any> => {
  try {
    const responseData = await axios.post(`${API_URLS.GENERATE_PASSWORD}`, formData);
    return responseData.data;
  } catch (error) {
    console.error("Error updating user consent:", error);
    throw error;
  }
};

export const changePassword = async (formData: any): Promise<any> => {
  try {
    const responseData = await axios.post(`${API_URLS.CHANGE_PASSWORD}`, formData);
    return responseData.data;
  } catch (error) {
    console.error("Error updating user consent:", error);
    throw error;
  }
};
export const externalSignin = async (formData: any): Promise<any> => {
  try {
    const responseData = await axios.post(`${API_URLS.EXTERNAL_LOGIN}`, formData);
    return responseData.data;
  } catch (error) {
    console.error("Error updating user consent:", error);
    throw error;
  }
};
